/**
 * The tenant the operator is working in, sent to messaging-gateway as `X-Tenant-Id`.
 * The gateway uses it only for global admins outside their own tenants (and ignores it for
 * everyone else), so sending it always is safe. Set by the tenant pages via useResolvedTenant.
 */
let activeTenantId: string | null = null;

export function setActiveTenantId(id: string | null): void {
  activeTenantId = id;
}

export function getActiveTenantId(): string | null {
  return activeTenantId;
}

/** `init` plus `X-Tenant-Id` when `url` targets the gateway (`apiServer`) and a tenant is active. */
export function withTenantHeader(url: string, init: RequestInit | undefined, apiServer: string): RequestInit {
  const base = init ?? {};
  if (!activeTenantId || !apiServer || !url.startsWith(apiServer)) return base;
  const headers = new Headers(base.headers);
  if (headers.has('X-Tenant-Id')) return base; // the caller named a tenant explicitly
  headers.set('X-Tenant-Id', activeTenantId);
  // A plain object, not the Headers instance: the SSO SDK's apiFetch spreads `init.headers`, and spreading a
  // Headers instance gives {} — Content-Type and X-Tenant-Id would never reach the gateway.
  return { ...base, headers: Object.fromEntries(headers) };
}

/** SSE/EventSource can't send headers: the gateway reads `tenantId` from the query instead. */
export function withTenantQuery(url: string, apiServer: string): string {
  if (!activeTenantId || !apiServer || !url.startsWith(apiServer)) return url;
  return `${url}${url.includes('?') ? '&' : '?'}tenantId=${encodeURIComponent(activeTenantId)}`;
}
